import VyomosPricing from './VyomosPricing';
import VyomosDemo from './VyomosDemo';
import VyomosContact from './VyomosContact';
import { StaticAbout } from './VyomosAbout';

// Former hard-coded marketing screens, now placeable/removable page blocks.
const BLOCKS = { pricing: VyomosPricing, demo: VyomosDemo, contact: VyomosContact, about: StaticAbout };

export function BuiltinSection({ s }) {
  const Comp = BLOCKS[s.variant];
  return Comp ? <div data-testid={`cms-builtin-${s.variant}`}><Comp /></div> : null;
}

export default BuiltinSection;
